module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Customers\r\n            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "13px"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.products.length))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', [_c('table', [_vm._m(1), _vm._v(" "), _vm._l((_vm.customers), function(data, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticClass: "card-avatar-circle",
      staticStyle: {
        "width": "30px",
        "height": "30px"
      }
    }, [(data.customer_image && (data.customer_image != '')) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": data.customer_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('p', [_vm._v(_vm._s(data.customer_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v(_vm._s(data.customer_phone))])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(data.customer_total_items_purchased))]), _vm._v(" "), _vm._m(2, true)])
  })], 2)])])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('p', [_vm._v("Search for Customer")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "border-radius": "8px"
    },
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('th', [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding-left": "1em",
      "padding-bottom": "1em",
      "font-size": "0"
    }
  }, [_vm._v("item")]), _vm._v(" "), _c('th', [_vm._v("items"), _c('br'), _vm._v("bought")]), _vm._v(" "), _c('th', [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "5%"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "color": "#5703a5"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4')]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "position": "fixed",
      "width": "100%",
      "bottom": "4.6em",
      "background": "#ffffff",
      "z-index": "10000"
    },
    attrs: {
      "id": "xInfo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    }
  }, [_vm._v("\r\n        Add Items to Shop")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72031c8e"}!./src/pages/Manage/Customers/template.html
// module id = 557
// module chunks = 0